import React from 'react';
import { observer } from 'mobx-react'
import { styled } from "../../stitches.config"
import SocialButtonLike from "../atoms/SocialButtonLike"
import SocialButtonComment from "../atoms/SocialButtonComment"
import SocialButtonShare from "../atoms/SocialButtonShare"
import { useStores, pushDataLayer } from "../../helpers"

import { IS_FEATURE_enableComments } from "../../components/common/constants/constants";

interface SocialsArticleProps {
    article: ArticleAuthor;
}

const SocialsArticle: React.FC<SocialsArticleProps> = observer(() => {
    const { ArticleStore } = useStores();
    const stats = ArticleStore.article.stats || {};
    const url = ArticleStore.article.fb_url;

    return (

        <StyledSocialsArticle>
            <div className="container">
                <div className="col-md-8 social-semi">
                    {/* brak statystyk polubień */}
                    <SocialButtonLike url={url} number={stats.likes} isDarkModeNotPrimary={true} showText={true} />
                    {IS_FEATURE_enableComments && <SocialButtonComment number={stats.comments} isDarkModeNotPrimary={true} showText={true} />}
                    <SocialButtonShare url={url} number={stats.shares} isDarkModeNotPrimary={true} showText={true} />
                </div>
            </div>
        </StyledSocialsArticle>

    );
});

const StyledSocialsArticle = styled('div', {
    width: "100%",
    "& .container": {
        overflowY: "visible !important"
    },
    "& .col-md-8": {
        padding: 0,
        borderTop: "1px solid $grayscale100",
        display: "flex",
        marginTop: "24px",
        paddingTop: "24px",
        "& div, a": {
            marginRight: "8px",
            "@bp4": {
                marginRight: "24px",
            }
        },
    },
    "& .social-semi": {
        minHeight: "32px"
    }
})

export default SocialsArticle